import { createHttpException } from '@belgattitude/http-exception';
import parseJson from 'json-parse-even-better-errors';

// In order to provide better DX, fetch and manually parse a JSON file. This is so that any error
// in parsing it can be caught and a message can be displayed directly in the browser as any issues
// in parsing this file should be considered a fatal error.
export async function fetchJson<T extends object>(
  url: RequestInfo | URL,
  options?: RequestInit,
): Promise<T | undefined> {
  const opts = <RequestInit> { credentials: 'include', ...options };

  const headers = new Headers(opts.headers);
  if (!headers.has('accept')) {
    headers.set('accept', 'application/json');
  }

  const response = await fetch(url, { ...opts, headers: Object.fromEntries(headers.entries()) });

  // Throw a dedicated HTTP exception.
  if (response?.status >= 400) {
    throw createHttpException(response.status, response.statusText);
  }

  return parseJson<T>(await response.text());
}
